import './DonateButtonLg.css';

function DonateButtonLg() {
  return (
    <a
      href="https://secure.actblue.com/donate/shield-pac-1"
      className="inline-flex items-center justify-center mx-auto mr-2 text-xl font-bold tracking-wide text-white uppercase rounded-sm DonateButtonLg blocky bg-cerulean"
    >
      Donate
    </a>
  );
}

export default DonateButtonLg;
